import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class HttpProfilerInterceptor implements HttpInterceptor {
  private enabled: boolean;
  private logEnabled: boolean;

  constructor() {
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    const isSafari = /Safari\//.test(ua) && !/Chrome\//.test(ua) && !/Chromium\//.test(ua);
    const debugFlag = (typeof location !== 'undefined' && /[?&]debug=1/.test(location.search)) || (typeof localStorage !== 'undefined' && localStorage.getItem('DEBUG') === '1');
    this.enabled = isSafari || debugFlag; // medir en Safari
    this.logEnabled = !!debugFlag;        // pero solo log si debug explícito
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.enabled) return next.handle(req);

    const t0 = performance.now?.() ?? Date.now();
    const markStart = `http:${req.method}:${req.urlWithParams}:start`;
    try { performance.mark(markStart); } catch {}

    return next.handle(req).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            this.finish(req.method, req.urlWithParams, t0, event.status);
          }
        },
        error: (err: HttpErrorResponse) => {
          this.finish(req.method, req.urlWithParams, t0, err.status || -1, true);
        }
      })
    );
  }

  private finish(method: string, url: string, t0: number, status: number, isError = false) {
    const t1 = performance.now?.() ?? Date.now();
    const dur = (t1 - t0).toFixed(1);
    const markEnd = `http:${method}:${url}:end`;
    try {
      performance.mark(markEnd);
      performance.measure(`http:${method}:${status}:${url}`, `http:${method}:${url}:start`, markEnd);
    } catch {}

    if (this.logEnabled) {
      this.scheduleIdle(() => {
        // eslint-disable-next-line no-console
  // console.log(`${isError ? '❌' : '🌐'} [HTTP] ${method} ${status} ${dur}ms ${this.trim(url)}`); // Silenciado
      });
    }

    try {
      const w = window as any;
      w.__httpPerf = w.__httpPerf || [];
      w.__httpPerf.push({ method, url, status, dur: Number(dur), t0, t1, error: isError });
      if (w.__httpPerf.length > 50) w.__httpPerf.shift();
    } catch {}
  }

  private trim(url: string, max = 120) {
    return url.length > max ? url.slice(0, max) + '…' : url;
  }

  private scheduleIdle(cb: () => void) {
    try {
      const w: any = typeof window !== 'undefined' ? window : undefined;
      const ric = w && typeof w.requestIdleCallback === 'function' ? w.requestIdleCallback : null;
      if (ric) {
        ric(() => cb(), { timeout: 500 });
      } else {
        setTimeout(cb, 0);
      }
    } catch {
      setTimeout(cb, 0);
    }
  }
}
